import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { fromEvent, takeUntil } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ComponentBase } from '../../data/component-base';

@Directive({
  selector: '[appInfiniteScroll]',
  standalone: true,
})
export class InfiniteScrollDirective extends ComponentBase implements OnInit {
  // TODO we need to check this scroll and infinite scroll lib
  // infinite scroll lib doesn't work properly when the dev is absolute
  @Input() triggerBefore = 0;
  @Input() throttleTime = 0;
  @Input() infiniteScrollDisabled = false;
  @Input() scrollContainer: Node | HTMLElement;
  @Output() scrolled = new EventEmitter();

  constructor(private elementRef: ElementRef) {
    super();
  }

  ngOnInit(): void {
    this._registerScrollerListener();
  }

  private _registerScrollerListener(): void {
    const scrollable = this.scrollContainer
      ? this.scrollContainer
      : this.elementRef.nativeElement;

    fromEvent(scrollable, 'scroll')
      .pipe(debounceTime(this.throttleTime), takeUntil(this.destroy$))
      .subscribe(() => {
        if (this.infiniteScrollDisabled) return;
        if (
          scrollable.scrollTop + scrollable.clientHeight >
          scrollable.scrollHeight - this.triggerBefore
        ) {
          this.scrolled.emit();
        }
      });
  }
}
